import React, { useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@app"
import { object, string } from "yup"

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsConditionName() {
	const {
		dataInfo, setDataInfo
	} = useAlertsDataInfo(alertsDrawerData.peek().conditionName || null)

	const { errors, isValid } = useValidatorSeeker({ conditionName: dataInfo.value }, object({
		conditionName: string().required("Must provide a condition's name")
			.min(5, "Conditions name must be at least 5 characters long")
			.max(100, "Conditions name can be at most 100 characters long")
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.value, conditionName: isValid }
	}, [JSON.stringify(errors)])

	return <TextFieldSeeker
		label="Condition Name"
		value={dataInfo.value || ""}
		onChange={a => setDataInfo(a.target.value, "conditionName")}
		error={errors?.conditionName}
	/>

}